module.exports = __webpack_public_path__ + "static/media/icons.771898a8.svg";